import React, {Component, Fragment} from "react";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SubTabPaketPenjualanContent from "./subTabPaketPenjualanContent";
import {configPaketPenjualan} from "./config";
import {v4 as uuidv4} from "uuid";
import {validateDataItem} from "../../../../masterPackage/util";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";
import Api from "../../../../../../Services/Api";
import {contructQueryParam, fetchDataAsync} from "../../../../../../Services/Utils";
import {HttpStatus} from "../../../../../common/Constants";
import SimpleAlert from "../../../../../../modules/popup/SimpleAlert";
import {mapToObjectDDL} from "../../../../../common/mapper";

class TabPaketPenjualan extends Component {
    tabList = [
        {label: "KSU", value: "ksu"},
        {label: "Hadiah", value: "hadiah"},
        {label: "Barang Lain", value: "barangLain"},
        {label: "Part", value: "part"}
    ];

    constructor(props) {
        super(props);
        this.initialDataDetail = {
            category: null,
            kode: null,
            name: null,
            satuan: null,
            jumlah: null,
            action: {readOnly: false, saved: false},
        };
        this.state = {
            loading: false,
            warningModalVisible: false,
            activeTab: {label: "KSU", value: "ksu"},
            tableColumns: [],
            dataCategory: [],
            dataItem: [],
            dataPackage: [],
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;
        this.fetchDataListPackage();
        const categoryType = configPaketPenjualan.getCategoryType(tabKey);
        const listCategory = await this.fetchDataCategory({
            paramFilters: {bizparCategory: categoryType}
        })
        this.setState({
            tableColumns: configPaketPenjualan.tableColumns(
                this.handleSaveRow,
                this.handleEditRow,
                this.handleCancelRow,
                this.handleDeleteRow,
                this.handleValueChange,
                this.handleCategoryChange,
                this.handleItemChange,
                listCategory,
                this.state.dataItem,
                tabKey,
            ),
            dataCategory: listCategory,
        });
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if ((prevProps.data.dataPackage.selectedPackage?.value !== this.props.data.dataPackage.selectedPackage?.value)
            && R.isNil(this.props.data.dataPackage.selectedPackage)) {
            this.props.onSetState((prevValue) => ({
                ...prevValue,
                data: {
                    ...prevValue.data,
                    dataPackage: {
                        selectedPackage: null,
                        selectedRow: null,
                        dataTable: {
                            ksu: [],
                            hadiah: [],
                            barangLain: [],
                            part: [],
                        },
                        dataDetailSaved: {
                            ksu: [],
                            hadiah: [],
                            barangLain: [],
                            part: [],
                        }
                    },
                },
            }));
        }
        if (prevState.activeTab !== this.state.activeTab) {
            this.handleTriggerLoading();
            const {activeTab} = this.state;
            const tabKey = activeTab?.value;
            const categoryType = configPaketPenjualan.getCategoryType(tabKey);
            const listCategory = await this.fetchDataCategory({
                paramFilters: {bizparCategory: categoryType}
            })
            this.setState((prevState) => ({
                ...prevState,
                tableColumns: configPaketPenjualan.tableColumns(
                    this.handleSaveRow,
                    this.handleEditRow,
                    this.handleCancelRow,
                    this.handleDeleteRow,
                    this.handleValueChange,
                    this.handleCategoryChange,
                    this.handleItemChange,
                    listCategory,
                    this.state.dataItem,
                    tabKey,
                ),
                dataCategory: listCategory,
            }));
            this.handleTriggerLoading();
        }

        if (prevState.dataItem !== this.state.dataItem) {
            const {activeTab} = this.state;
            const tabKey = activeTab?.value;
            this.setState((prevState) => ({
                ...prevState,
                tableColumns: configPaketPenjualan.tableColumns(
                    this.handleSaveRow,
                    this.handleEditRow,
                    this.handleCancelRow,
                    this.handleDeleteRow,
                    this.handleValueChange,
                    this.handleCategoryChange,
                    this.handleItemChange,
                    prevState.dataCategory,
                    prevState.dataItem,
                    tabKey,
                ),
            }));
        }
    }

    handleTabChange = (activeTab) => {
        this.setState((prevState) => ({
            ...prevState,
            activeTab,
        }));
    };

    mergeByKode = (rows) => {
        if(rows.length === 0) return [];
        return  Array.from(
            rows.reduce((map, item) => {
                const key = item?.kode || null;
                const jumlah = Number(item.jumlah) || 0;
                if (map.has(key)) {
                    map.get(key).jumlah += jumlah;
                } else {
                    map.set(key, { ...item, jumlah });
                }
                return map;
            }, new Map()).values()
        );
    }

    handlePackageChange = async (name, value) => {
        let dataTable = {};
        if (value) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getMasterPackageById,
                setError: this.props.setError,
                menuName: "Faktur Jual - Paket Penjualan",
                args: contructQueryParam({idPackage: value?.value}),
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                const {listKSU, listGift, listOtherItem, listPart} = res.data.data;
                
                const tempKSU = R.isEmpty(listKSU) ? [] : listKSU.map(item => {
                    return {
                        id: uuidv4(),
                        category: {label: item?.dataKSU?.category?.value, value: item?.dataKSU?.category?.key},
                        kode: item?.dataKSU?.kodeKSU,
                        name: {label: item?.dataKSU?.name, value: item?.dataKSU?.name},
                        satuan: item?.dataKSU?.satuan?.value,
                        jumlah: item?.qty,
                        action: {
                            readOnly: true,
                            saved: true,
                        }
                    }
                });


                const tempHadiah = R.isEmpty(listGift) ? [] : listGift.map(item => {
                    return {
                        id: uuidv4(),
                        category: {
                            label: item?.hadiahDTO?.categoryDTO?.value,
                            value: item?.hadiahDTO?.categoryDTO?.key
                        },
                        kode: item?.hadiahDTO?.kodeHadiah,
                        name: {label: item?.hadiahDTO?.nameHadiah, value: item?.hadiahDTO?.nameHadiah},
                        satuan: item?.hadiahDTO?.satuanDTO?.value,
                        jumlah: item?.qty,
                        action: {
                            readOnly: true,
                            saved: true,
                        }
                    }
                })

                const tempBarangLain= R.isEmpty(listOtherItem) ? [] : listOtherItem.map(item => {
                    return {
                        id: uuidv4(),
                        category: {
                            label: item?.otherItemResponseDTO?.categoryDTO?.value,
                            value: item?.otherItemResponseDTO?.categoryDTO?.key
                        },
                        kode: item?.otherItemResponseDTO?.kodeotheritem,
                        name: {
                            label: item?.otherItemResponseDTO?.nameotheritem,
                            value: item?.otherItemResponseDTO?.nameotheritem
                        },
                        satuan: item?.otherItemResponseDTO?.satuanDTO?.value,
                        jumlah: item?.qty,
                        action: {
                            readOnly: true,
                            saved: true,
                        }
                    }
                })

                const tempPart = R.isEmpty(listPart) ? [] : listPart.map(item => {
                    return {
                        id: uuidv4(),
                        category: {label: item?.part?.partCategory?.value, value: item?.part?.partCategory?.key},
                        kode: item?.part?.kodePart,
                        name: {label: item?.part?.partName, value: item?.part?.partName},
                        satuan: item?.part?.satuan?.value,
                        jumlah: item?.qty,
                        action: {
                            readOnly: true,
                            saved: true,
                        }
                    }
                })

                dataTable = {
                    ksu: this.mergeByKode(tempKSU),
                    hadiah: this.mergeByKode(tempHadiah),
                    barangLain:this.mergeByKode(tempBarangLain),
                    part: this.mergeByKode(tempPart),
                }
            }
        }

        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataPackage: {
                    ...prevState.data.dataPackage,
                    selectedPackage: value,
                    dataTable: dataTable,
                    dataDetailSaved: dataTable
                }
            }
        }))
    }

    handleWarningModalVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            warningModalVisible: !prevState.warningModalVisible,
        }))
    }

    handleAddRow = () => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;
        const newData = {
            id: uuidv4(),
            ...this.initialDataDetail,
        }

        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataPackage: {
                    ...prevState.data.dataPackage,
                    dataTable: {
                        ...prevState.data.dataPackage.dataTable,
                        [tabKey]: [...prevState.data.dataPackage.dataTable[tabKey], newData],
                    }
                }
            }
        }))
    };

    handleSaveRow = (index) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;
        const rowData = this.props.data.dataPackage.dataTable[tabKey][index];

        const errors = validateDataItem(rowData);
        if (!R.isNil(errors) && !R.isEmpty(errors)) {
            this.handleWarningModalVisibility();
            return;
        }

        this.props.onSetState((prevState) => {
            const prevTabData = [...prevState.data.dataPackage.dataTable[tabKey]];

            // Toggle saved status
            const updatedRow = {
                ...prevTabData[index],
                action: {
                    ...prevTabData[index].action,
                    saved: !prevTabData[index].action.saved,
                },
            };

            prevTabData[index] = updatedRow;

            // Merge by 'kode'
            const mergedData = Array.from(
                prevTabData.reduce((map, item) => {
                    const key = item.kode;
                    const jumlah = Number(item.jumlah);
                    if (map.has(key)) {
                        map.get(key).jumlah += jumlah;
                    } else {
                        map.set(key, {...item, jumlah});
                    }
                    return map;
                }, new Map()).values()
            );

            // Update selectedRow
            let updatedSelected = prevState.data.dataPackage.selectedRow;
            if (!R.isNil(prevState.data.dataPackage.selectedRow)) {
                const prevSelected = Object.values(prevState.data.dataPackage.selectedRow?.[tabKey] || []);
                updatedSelected = prevSelected.filter(item => item.id !== updatedRow.id);
            }

            return {
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        dataTable: {
                            ...prevState.data.dataPackage.dataTable,
                            [tabKey]: mergedData,
                        },
                        dataDetailSaved: {
                            ...prevState.data.dataPackage.dataDetailSaved,
                            [tabKey]: mergedData,
                        },
                        selectedRow: {
                            ...prevState.data.dataPackage.selectedRow,
                            [tabKey]: updatedSelected,
                        },
                    },
                },
            };
        });
    };

    handleEditRow = async (index) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;

        this.props.onSetState((prevState) => {
            const prevDataTable = prevState.data.dataPackage.dataTable[tabKey] || [];
            const updatedRow = {
                ...prevDataTable[index],
                action: {
                    ...prevDataTable[index].action,
                    saved: !prevDataTable[index].action.saved,
                },
            };

            const updatedDataTable = [...prevDataTable];
            updatedDataTable[index] = updatedRow;

            const prevSelectedRow = prevState.data.dataPackage.selectedRow?.[tabKey] || {};
            const updatedSelectedRow = {
                ...prevSelectedRow,
                [index]: prevDataTable[index], // storing old version before toggle
            };

            return {
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        dataTable: {
                            ...prevState.data.dataPackage.dataTable,
                            [tabKey]: updatedDataTable,
                        },
                        selectedRow: {
                            ...prevState.data.dataPackage.selectedRow,
                            [tabKey]: updatedSelectedRow,
                        },
                    },
                },
            };
        });

        const categoryId = this.props.data.dataPackage.dataTable[tabKey]?.[index]?.category?.value;
        await this.fetchDataItem(index, tabKey, categoryId);
    };

    handleCancelRow = (index) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;

        this.props.onSetState((prevState) => {
            const prevDataTable = prevState.data.dataPackage.dataTable[tabKey] || [];
            const selectedRowMap = prevState.data.dataPackage.selectedRow?.[tabKey] || {};
            const currentRow = prevDataTable[index];

            let updatedDataTable;

            if (Object.keys(selectedRowMap).length === 0) {
                // No selected rows, remove the row entirely
                updatedDataTable = prevDataTable.filter((_, idx) => idx !== index);
            } else {
                // Restore from selectedRow map (assumes keyed by index or some object with `id`)
                const restoredRow = Object.values(selectedRowMap).find(item => item.id === currentRow.id);
                updatedDataTable = [...prevDataTable];
                updatedDataTable[index] = restoredRow || currentRow;
            }

            // Clean up selectedRow by removing the one we just restored
            const updatedSelectedRowMap = Object.values(selectedRowMap)
                .filter(item => item.id !== currentRow.id)
                .reduce((acc, item, idx) => {
                    acc[idx] = item;
                    return acc;
                }, {});

            const updatedSelectedRow =
                Object.keys(updatedSelectedRowMap).length > 0
                    ? {
                        ...prevState.data.dataPackage.selectedRow,
                        [tabKey]: updatedSelectedRowMap,
                    }
                    : null;

            return {
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        dataTable: {
                            ...prevState.data.dataPackage.dataTable,
                            [tabKey]: updatedDataTable,
                        },
                        selectedRow: updatedSelectedRow,
                    },
                },
            };
        });
    };

    handleDeleteRow = (index) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;

        this.props.onSetState((prevState) => {
            const dataTable = prevState.data.dataPackage.dataTable[tabKey] || [];
            const dataDetailSaved = prevState.data.dataPackage.dataDetailSaved[tabKey] || [];

            return {
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        dataTable: {
                            ...prevState.data.dataPackage.dataTable,
                            [tabKey]: dataTable.filter((_, idx) => idx !== index),
                        },
                        dataDetailSaved: {
                            ...prevState.data.dataPackage.dataDetailSaved,
                            [tabKey]: dataDetailSaved.filter((_, idx) => idx !== index),
                        },
                    },
                },
            };
        });
    };

    handleValueChange = (index, name, value) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;

        this.props.onSetState((prevState) => {
            const dataTable = [...(prevState.data.dataPackage.dataTable[tabKey] || [])];

            dataTable[index] = {
                ...dataTable[index],
                [name]: value,
            };

            return {
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        dataTable: {
                            ...prevState.data.dataPackage.dataTable,
                            [tabKey]: dataTable,
                        },
                    },
                },
            };
        });
    };

    handleCategoryChange = async (index, name, value) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;

        this.props.onSetState((prevState) => {
            const dataTable = [...(prevState.data.dataPackage.dataTable[tabKey] || [])];

            dataTable[index] = {
                ...dataTable[index],
                [name]: value,
                name: null,
                kode: null,
                satuan: null,
            };

            return {
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        dataTable: {
                            ...prevState.data.dataPackage.dataTable,
                            [tabKey]: dataTable,
                        },
                    },
                },
            };
        });

        this.handleTriggerLoading();
        await this.fetchDataItem(index, tabKey, value.value);
        this.handleTriggerLoading();
    }

    handleItemChange = (index, name, value) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;

        this.props.onSetState((prevState) => {
            const dataTable = [...(prevState.data.dataPackage.dataTable[tabKey] || [])];

            dataTable[index] = {
                ...dataTable[index],
                [name]: value,
                kode: value.value,
                satuan: value.satuan,
            };

            return {
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        dataTable: {
                            ...prevState.data.dataPackage.dataTable,
                            [tabKey]: dataTable
                        }
                    }
                }
            }
        })
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    fetchDataCategory = async (body) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
            setError: this.props.setError,
            menuName: "Faktur Jual - Paket Penjualan",
            args: body,
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            return res.data.data.map(item => ({
                value: item.key,
                label: item.value
            }))
        }
    }

    fetchDataItem = async (index, type, body) => {
        const {activeTab} = this.state;
        const tabKey = activeTab?.value;
        let res = null;
        switch (type) {
            case "ksu" :
                res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKSUPagingByParam,
                    setError: this.props.setError,
                    menuName: "Faktur Jual - Paket Penjualan",
                    args: {paramFilters: {category: body}},
                });

                this.setState((prevState) => ({
                    ...prevState,
                    dataItem: {
                        ...prevState.dataItem,
                        [tabKey]: {
                            ...prevState.dataItem[tabKey],
                            [index]: res.data.data?.map(item => ({
                                value: item.kodeKSU,
                                label: item.name,
                                satuan: item.satuanDTO?.value,
                            }))
                        }
                    },
                }));

                return;
            case "hadiah" :
                res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllHadiahPagingByParam,
                    setError: this.props.setError,
                    menuName: "Faktur Jual - Paket Penjualan",
                    args: {paramFilters: {categoryHadiah: body}},
                });

                this.setState((prevState) => ({
                    ...prevState,
                    dataItem: {
                        ...prevState.dataItem,
                        [tabKey]: {
                            ...prevState.dataItem[tabKey],
                            [index]: res.data.data?.map(item => ({
                                value: item.kodeHadiah,
                                label: item.nameHadiah,
                                satuan: item.satuanHadiah,
                            }))
                        }
                    },
                }));

                return;
            case "barangLain" :
                res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllOtherItemPagingByParam,
                    setError: this.props.setError,
                    menuName: "Faktur Jual - Paket Penjualan",
                    args: {paramFilters: {categoryotheritem: body}},
                });

                this.setState((prevState) => ({
                    ...prevState,
                    dataItem: {
                        ...prevState.dataItem,
                        [tabKey]: {
                            ...prevState.dataItem[tabKey],
                            [index]: res.data.data?.map(item => ({
                                value: item.kodeotheritem,
                                label: item.nameotheritem,
                                satuan: item.satuanotheritem,
                            }))
                        }
                    },
                }));

                return;
            case "part" :
                res = await fetchDataAsync({
                    asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart,
                    setError: this.props.setError,
                    menuName: "Faktur Jual - Paket Penjualan",
                    args: {paramFilters: {partcategory: body}},
                });

                this.setState((prevState) => ({
                    ...prevState,
                    dataItem: {
                        ...prevState.dataItem,
                        [tabKey]: {
                            ...prevState.dataItem[tabKey],
                            [index]: res.data.data?.map(item => ({
                                value: item.kodePart,
                                label: item.partName,
                                satuan: item.satuan,
                            }))
                        }
                    },
                }));

                return;
        }
    }

    fetchDataListPackage = async () => {
        const dataUnit = this.props.data?.dataUnit;
        const objKodeVarian = this.props.data?.dataUnit?.kodeVariant;
        const kodeVarian = !dataUnit?.nomorMesin || !dataUnit?.nomorRangka ? objKodeVarian?.label : objKodeVarian?.value || null;
        if (kodeVarian) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getListPackageSalesOrder,
                setError: this.props.setError,
                menuName: "Faktur Jual - Paket Penjualan",
                args: {
                    kodeCabang: this.props.data.kodeCabang?.value,
                    kodeVarian: kodeVarian
                },
            });

            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevState) => ({
                    ...prevState,
                    dataPackage: res.data.data.map(item => mapToObjectDDL(item.packageName, item.packageId))
                }));
            }
        }
    }

    render() {
        return (
            <>
                <FlexView column style={{gap: 20}}>
                    <div className="grid grid-2x gap-20px grid-mobile-none">
                        <div id="grid-1">
                            <SimpleDDL
                                id="select_options_nama_paket"
                                styles={{width: "30%"}}
                                name="selectedPackage"
                                label="Nama Paket"
                                box="search"
                                mandatory
                                errorMessage={this.props.errors?.["dataPackage"]?.selectedPackage}
                                options={this.state.dataPackage}
                                isClearable
                                readOnly={!this.props.state.isEditable}
                                value={this.props.data?.dataPackage?.selectedPackage}
                                onChange={(value, {name}) => this.handlePackageChange(name, value)}
                            />
                        </div>
                        <div id="grid-2"></div>
                    </div>
                    <SimpleButton
                        text="Tambah"
                        icon={<i className="fa fa-plus margin-right-10px"/>}
                        className="margin-left-none"
                        disabled={!this.props.state.isEditable}
                        onClick={this.handleAddRow}
                    />
                    <SubTabPaketPenjualanContent
                        {...this.props}
                        tabList={this.tabList}
                        activeTab={this.state.activeTab}
                        state={this.state}
                        handleTabChange={this.handleTabChange}
                    />
                </FlexView>

                {this.state.warningModalVisible && (
                    <SimpleAlert
                        title={"Information"}
                        content={
                            <div>
                                <p>
                                    Ada field data yang perlu diisi atau tidak sesuai kriteria isian.
                                    <br/>
                                    Mohon periksa kembali.
                                </p>
                            </div>
                        }
                        additionalButtons={
                            <Fragment>
                                <FlexView>
                                    <SimpleButton
                                        text="OK"
                                        secondary
                                        onClick={() => this.handleWarningModalVisibility()}
                                    />
                                </FlexView>
                            </Fragment>
                        }
                        visible={this.state.warningModalVisible}
                        onClickClose={this.handleWarningModalVisibility}
                    />
                )}

                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

export default TabPaketPenjualan;